export function gforms() {

    $('.questionnaire-popup-launcher').on('click', function () {
        $('.questionnaire-popup-launcher').removeClass('active');
        $(this).addClass('active');
    });

    jQuery(document).on('gform_confirmation_loaded', function(event, formId){
        if(formId == 2) {
            $('.cp-adjacent-close').trigger('click');
            window.location.href = document.querySelector('.questionnaire-popup-launcher.active').getAttribute('data-url');
        }
    });

}


// WEBPACK FOOTER //
// ./assets/js/modules/gforms.js